<button class="help-trigger" (click)="toggleExpand()" type="button">
  <fa-icon [icon]="faInfoCircle"></fa-icon>
</button>

@if (expanded && contentState$) {
  <div class="help-inline-content">
    @if (contentState$ | async; as state) {
      @if (state.status === "loading") {
        <div class="loading"></div>
      }

      @if (state.status === "error") {
        <div class="error">
          {{ state.error }}
        </div>
      }

      @if (state.status === "success") {
        <div class="content" [innerHTML]="state.content"></div>
      }
    }
  </div>
}
